import history from "redux/history";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

export const initializeMonitoring = () => {
  // eslint-disable-next-line
  if (process.env.REACT_APP_SENTRY_DSN) {
    Sentry.init({
      // eslint-disable-next-line
      dsn: process.env.REACT_APP_SENTRY_DSN,
      integrations: [
        new Integrations.BrowserTracing({
          routingInstrumentation: Sentry.reactRouterV5Instrumentation(history)
        })
      ],
      tracesSampleRate: 0.1
    });
  }
};
